<template>
  <v-container>
    <v-layout>
      <v-flex>
        <h3>Conjugate the verb.</h3>
        <!-- <v-btn @click="generateQuestion">New Question</v-btn> -->
        <h2 v-show="prompt">Verb: {{prompt ? prompt.verb : ""}}</h2>
        <div v-show="prompt">Tense: {{prompt ? prompt.tense : ""}}</div>
        <div v-show="prompt">Person: {{prompt ? prompt.person : ""}}</div>
        <div v-show="prompt">Number: {{prompt ? prompt.number : ""}}</div>
        <div v-show="prompt">Dependent Form: {{prompt ? prompt.depForm : ""}}</div>
        <div v-if="prompt">
          <v-text-field label="Answer" v-model="verbAnswer"></v-text-field>
          <!-- <v-btn v-show="!answered" @click="onSubmit">Check</v-btn> -->
          <h3 v-show="answered">{{correct ? "Correct" : "Incorrect"}}</h3>
          <h3 v-show="answered">Answers</h3>
          <div
            v-show="answered"
            v-for="(answer,index) in prompt.answers"
            v-bind:key="index"
          >{{answer}}</div>
        </div>
      </v-flex>
    </v-layout>
    <v-layout class="btn-bottom">
      <v-btn
        @click="handleAnswer"
        v-if="!answered"
        :disabled="verbAnswer && verbAnswer.length <= 0"
        color="primary"
        round
        outline
      >Check</v-btn>
      <v-btn round outline color="primary" @click="handleSubmit" v-else>Next</v-btn>
      <v-btn round outline color="primary" @click="handleSkip" v-if="!answered">Skip</v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import {
  PARTS_OF_SPEECH,
  GENDER,
  VERB_TENSES,
  VERB_PERSON,
  VERB_NUMBER,
  VERB_CATEGORY,
  SAMPLE_VERBS,
} from "@/constants.js";
import {
  conjugate,
  generateStem,
  enumerateConjugations,
  simplifyWord
} from "@/conjugation.js";
import { randomConjugationPrompt } from "@/verbprompts.js";
export default {
  name: "ParametersToConjugation",
  props: {
    prompt: {
      type: Object,
      default: function(){ return randomConjugationPrompt(_.sample(SAMPLE_VERBS))},
    },
    controlled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      verbStem: "",
      // prompt: null,
      verbAnswer: "",
      answered: false,
      correct: false,
    };
  },
  methods: {
    onSubmit() {
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    clear() {
      if (this.controlled) {
          this.$emit("next");
      }
      else{
        this.prompt = randomConjugationPrompt(_.sample(SAMPLE_VERBS))
      }
      this.answered = false;
      this.verbAnswer = "";
    },
    handleSubmit: function () {
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    handleAnswer: function () {
      this.answered = true;
      this.correct = this.prompt.answers.map(simplifyWord).indexOf(simplifyWord(this.verbAnswer)) >= 0;
      this.$emit("check", { correct: this.correct });
      // this.correct = this.prompt.answers.indexOf(this.verbAnswer) >= 0;
    },
    handleSkip: function () {
      this.clear();
    },
  },
};
</script>

<style scoped>
incorrect {
  color: red;
}
th,
td {
  outline: 1px solid black;
  padding: 1em;
}
.btn-bottom {
  position: absolute;
  bottom: 0;
  padding: 16px 0px;
}
</style>
